import {
  Box,
  Carousel,
  DsmColor,
  Grid,
  GridColumn,
  CarouselSlide,
} from "@kohler-dsm-library/kohler-core";
import clsx from "clsx";
import React, { useState, useEffect } from "react";
import VisualFilterCard from "./subcomponents/VisualFilterCard.jsx";
import classes from "./index.module.scss";
import { useRouter } from "next/router";
import { useDeviceType } from "@/hooks/useDeviceType";

const WalkinCarousel = ({ walkinCarouselData }) => {
  if (!walkinCarouselData) return null;
  const router = useRouter();
  const { locale } = router;

  const [slideSize, setSlideSize] = useState("33.33%");

  useEffect(() => {
    function updateSlideSize() {
      const width = window.innerWidth;

      if (width <= 480) {
        setSlideSize("100%");
      } else if (width <= 840) {
        setSlideSize("50%");
      } else {
        setSlideSize("33.33%");
      }
    }

    updateSlideSize(); // run on mount
    window.addEventListener("resize", updateSlideSize);

    return () => window.removeEventListener("resize", updateSlideSize);
  }, []);

  const {
    title,
    images: cards = [],
    hideContentOn = "both",
  } = walkinCarouselData;
  let hideContent = false;

  switch (locale) {
    case "vn":
      hideContent = hideContentOn === "vn" ? true : false;
      break;

    case "en":
      hideContent = hideContentOn === "en" ? true : false;
      break;

    default:
      hideContent = false;
  }
  const contentClass = hideContent ? "hidden" : "";

  return (
    <section
      className={clsx(
        classes.carouselWrapper,
        "koh-three-image-product-carousel",
        contentClass
      )}
    >
      <div className="koh-product-carousel">
        <div class="koh-text-description">{title}</div>
        <Box
          component="div"
          mod="white"
          backgroundColor={DsmColor.BackgroundPrimary}
          maxWidth="100%"
          style={{ overflow: "hidden" }}
          className={clsx("kohler-visual-filter-root")}
        >
          <Grid>
            <GridColumn className={classes.visualFilterContent}>
              <Carousel
                includeGapInSize={false}
                slideGap="0px"
                slideSize={slideSize}
                breakpoints={[
                  { maxWidth: 1200, slideSize: "33.333333%" },
                  { maxWidth: 768, slideSize: "50%" },
                  { maxWidth: 480, slideSize: "100%" },
                ]}
                align="start"
                loop={true}
                containScroll="trimSnaps"
                carouselControlProps={{
                  variant: "slider",
                  isOnPhoto: true,
                }}
                className={classes.visualFilter}
              >
                {cards.map(imageCard => (
                  <CarouselSlide
                    className={classes.productCardCarouselCard}
                    key={imageCard?.sys?.id}
                  >
                    <VisualFilterCard {...imageCard?.fields} />
                  </CarouselSlide>
                ))}
              </Carousel>
            </GridColumn>
          </Grid>
        </Box>
      </div>
    </section>
  );
};

export default WalkinCarousel;
